import React, { useState } from "react";
import { GraphMenu } from "components/DataExplorationV2/GraphMenu";
import { GraphMenuSection } from "components/DataExplorationV2/GraphMenuSection";
import { TitleSection } from "components/DataExplorationV2/EditMenu/TitleSection/TitleSection";
import { styled } from "@mui/material/styles";

enum Section {
  TITLE = "title"
}

export interface EditMenuProps {
  /** The string value for chart title */
  title: string;
  onChangeTitle: (name: string) => void;
}

export const EditMenu = ({
  title,
  onChangeTitle
}: EditMenuProps): JSX.Element => {
  const [expandedSection, setExpandedSection] = useState<string | null>(
    "title"
  );

  const handleToggleSection = (sectionKey: string): void => {
    setExpandedSection(prevState =>
      prevState !== sectionKey ? sectionKey : null
    );
  };

  return (
    <GraphMenu title="Edit">
      <GraphMenuSection
        title="Title"
        expanded={expandedSection === Section.TITLE}
        onToggleExpanded={() => handleToggleSection(Section.TITLE)}
      >
        <ComponentWrap>
          <TitleSection title={title} onChangeTitle={onChangeTitle} />
        </ComponentWrap>
      </GraphMenuSection>
    </GraphMenu>
  );
};

const ComponentWrap = styled("div")`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
`;
